import LoyaltyPage from './LoyaltyPage';
import loyaltyPageReducer from './reducer';

export { loyaltyPageReducer };
export default LoyaltyPage;
